<script setup lang="ts">
import BalmDialog from '@/vue/atoms/balm-dialog.vue';
import BalmBtn from '@/vue/atoms/balm-btn.vue';
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

const isOpen = defineModel<boolean>();

function onDismiss(): void {
  isOpen.value = false;
}
</script>

<template>
  <balm-dialog
    v-model="isOpen"
    type="fit-content"
    theme="grey-10"
    no-padding
    desktop-from-tablet
    x-close-color="var(--Neutral-UI-neutral-ui-40)"
  >
    <div class="challenge-expired-modal">
      <div class="illustration-container">
        <svg-illustration name="expired-plan-decoration.svg" class="illustration"/>
      </div>

      <div class="content">
        <h2 class="title">
          {{ $t('challenge_expired_title') }}
        </h2>
        <p class="message">
          {{ $t('challenge_expired_message') }}
        </p>
      </div>

      <div class="actions">
        <balm-btn
          :label="$t('challenge_expired_cta')"
          paddings="p2-5"
          @click="onDismiss"
        />
      </div>
    </div>
  </balm-dialog>
</template>

<style scoped lang="scss">
.challenge-expired-modal {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--Spacing-spacing-6);
  text-align: left;
  min-width: 300px;

  @include screen-md {
    min-width: 400px;
    max-width: 440px;
    padding: var(--Spacing-spacing-7) var(--Spacing-spacing-6) var(--Spacing-spacing-6);
  }
}

.illustration-container {
  width: 88px;
  max-width: 100%;
  margin-bottom: var(--Spacing-spacing-4);
  // The calendar artwork has ~20% transparent padding on its left inside the
  // asset; shift it back so its visible left edge aligns with the text.
  transform: translateX(-20%);

  @include screen-md {
    width: 100px;
  }

  .illustration :deep(svg) {
    width: 100%;
    height: auto;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-spacing-2);
}

.title {
  @include font-display-3;
  color: var(--Neutral-UI-neutral-ui-100);
  margin: 0;
}

.message {
  @include font-body;
  color: var(--Neutral-UI-neutral-ui-70);
  margin: 0;
}

.actions {
  align-self: stretch;
  display: flex;
  margin-top: var(--Spacing-spacing-9);

  :deep(.balm-btn) {
    width: 100%;
  }

  @include screen-md {
    justify-content: flex-end;
    // spacing-9 resolves to 84px at the desktop breakpoint, which is too large
    // here; keep the desktop gap tighter.
    margin-top: var(--Spacing-spacing-6);

    :deep(.balm-btn) {
      width: auto;
    }
  }
}
</style>
